import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { GasUse } from '../../../models/onboarding';

@Component({
  selector: 'alg-gas-radio',
  templateUrl: './alg-gas-radio.component.html',
  styleUrls: ['./alg-gas-radio.component.scss']
})
export class AlgGasRadioComponent implements OnInit {
  @Output() select = new EventEmitter<any>();
  public cardSelectedType: string;
  public typeGas: string;
  public isGas = "gas";
  public isWater = "water";
  public isGasActive: boolean;
  public isWaterActive: boolean;
  public isBothActive: boolean;
  constructor() { }

  ngOnInit() {
    this.isBothActive = false
  }


  onWaterCheck(form: NgForm){
    if(form.value.water){
      this.isWaterActive = true;
      this.typeGas = GasUse.cottura;
    } else {
      this.isWaterActive = false;
    }
    return this.checkEmit();
  }

  onGasCheck(form: NgForm){
    if(form.value.radiator){
      this.isGasActive = true
      this.typeGas = GasUse.riscaldamento;
    } else {
      this.isGasActive = false
    }
    return this.checkEmit();
  }


  checkEmit(){
    if(this.isGasActive && this.isWaterActive) this.typeGas = GasUse.acqua;
    return this.select.emit(this.typeGas);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-gas-radio/alg-gas-radio.component.ts